import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import get from 'lodash/get';
import { projectType, sortOptionType, paginationOptionsType } from 'types';

/* eslint-disable react/destructuring-assignment */

import {
  getProjectsList,
  toggleProjectsGrid,
} from 'store/services/projects/actions';
import { selectProject } from 'store/services/project/actions';

import * as projectSelectors from 'store/services/projects/selectors';

import Button from 'components/Button';
import Pagination from 'components/Pagination';

import Layout from 'components/Layout';
import ProjectsList from './components/ProjectsList';
import FakeProjectsList from './components/FakeProjectsList';
import ProjectsOptions from './components/ProjectsOptions';
import NoProjects from './components/NoProjects';
import NoSearchResults from './components/NoSearchResults';
import CreateProjectModal from './scenes/CreateProjectModal';

import './style.scss';

export class Projects extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    count: PropTypes.number,
    getProjects: PropTypes.func,
    isGrid: PropTypes.bool,
    isLoading: PropTypes.bool,
    paginationOptions: paginationOptionsType,
    projects: PropTypes.arrayOf(projectType),
    selectedSortOption: sortOptionType,
    selectProject: PropTypes.func,
    sortOptions: PropTypes.arrayOf(sortOptionType),
    toggleGridView: PropTypes.func,
  };

  componentDidMount() {
    this.props.getProjects();
  }

  handleGridView = ({ isGrid }) => this.props.toggleGridView(isGrid);

  handleOpenCreateProjectModal = () => this.props.history.push('/new');

  handleCloseCreateProjectModal = () => this.props.history.push('/');

  handleOpenProject = project => {
    // FIXME: user url to select project
    this.props.selectProject(project);
    this.props.history.push(`/${project.account}/${project.slug}/entities`);
  };

  renderProjectsOptions(isLoading, projects, searchTerm) {
    const { isGrid, getProjects, sortOptions, selectedSortOption } = this.props;

    if (projects.length || isLoading || searchTerm !== '') {
      return (
        <ProjectsOptions
          getProjects={getProjects}
          isGrid={isGrid}
          options={sortOptions}
          projects={projects}
          searchTerm={searchTerm}
          selectedSortOption={selectedSortOption}
          toggleGridView={this.handleGridView}
        />
      );
    }

    return null;
  }

  renderFakeProjects = isLoading => {
    if (isLoading) {
      const { isGrid } = this.props;

      return <FakeProjectsList isGrid={isGrid} />;
    }

    return null;
  };

  renderProjects(isLoading, projects) {
    if (projects.length && !isLoading) {
      return (
        <ProjectsList
          isGrid={this.props.isGrid}
          projects={projects}
          selectProject={this.handleOpenProject}
        />
      );
    }

    return null;
  }

  // eslint-disable-next-line class-methods-use-this
  renderNoProjects(isLoading, projects, searchTerm) {
    if (!projects.length && !isLoading && !searchTerm) {
      return <NoProjects onCreateProject={this.handleOpenCreateProjectModal} />;
    }

    return null;
  }

  renderNoSearchResults(projects, isLoading, searchTerm) {
    if (!isLoading && !projects.length && searchTerm !== '') {
      const { getProjects } = this.props;

      return (
        <NoSearchResults getProjects={getProjects} searchTerm={searchTerm} />
      );
    }

    return null;
  }

  renderPagination(projects) {
    if (projects.length) {
      const { count, paginationOptions, getProjects } = this.props;

      return (
        <Pagination
          count={count}
          getItems={getProjects}
          paginationOptions={paginationOptions}
        />
      );
    }

    return null;
  }

  renderCreateProjectModal = () => {
    const { count } = this.props;

    return (
      <Route
        path="/new"
        render={() => (
          <CreateProjectModal
            projectsCount={count}
            onCloseRequest={this.handleCloseCreateProjectModal}
          />
        )}
      />
    );
  };

  render() {
    const { isLoading, projects } = this.props;
    // FIXME: use camelcase `name__icontains`
    const searchTerm = get(this.props.paginationOptions, 'name__icontains');

    return (
      <Layout>
        <Helmet>
          <title>Omilia Conversation Studio</title>
        </Helmet>

        <main className="main-content" id="main">
          {this.renderCreateProjectModal()}
          <div styleName="header">
            <h3 styleName="title">Projects</h3>
            <Button
              data-test="open-create-project-modal"
              onClick={this.handleOpenCreateProjectModal}
            >
              Create Project
            </Button>
          </div>
          <div styleName="container">
            {this.renderProjectsOptions(isLoading, projects, searchTerm)}
            {this.renderProjects(isLoading, projects)}
            {this.renderFakeProjects(isLoading, projects)}
            {this.renderNoProjects(isLoading, projects, searchTerm)}
            {this.renderNoSearchResults(projects, isLoading, searchTerm)}
            {this.renderPagination(projects)}
          </div>
        </main>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  // Project:
  isGrid: projectSelectors.getIsGrid(state),
  sortOptions: projectSelectors.getFilteredSortOptions(state),
  selectedSortOption: projectSelectors.getSelectedSortOption(state),
  paginationOptions: projectSelectors.getPaginationOptions(state),
  isLoading: projectSelectors.getIsLoadingList(state),
  count: projectSelectors.getProjectsListCount(state),
  projects: projectSelectors.getProjectsList(state),
});

const mapDispatchToProps = dispatch => ({
  getProjects: bindActionCreators(getProjectsList, dispatch),
  selectProject: bindActionCreators(selectProject, dispatch),
  toggleGridView: bindActionCreators(toggleProjectsGrid, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Projects);
